import { useTelemetryViewEvent } from 'common/hooks';
import { EntityType } from 'common/types';
import {
  businessInsightsInteractionClickChartSource,
  businessInsightsInteractionClickDatePicker,
  SourceTitleValueType,
  SourceTitle,
  TargetContentDatePickerValueType,
  TargetContentDatePicker,
  businessInsightsV2View,
  businessInsightsV2InteractionClickSwitchToOldInsights,
  businessInsightsV2PerformanceView,
  businessInsightsV2OperationsView,
  businessInsightsV2CustomerBaseView,
  businessInsightsV2MenuView,
  businessInsightsV2RatingsReviewsView,
  businessInsightsV2RatingsReviewsInteractionClickFilterRatings,
  businessInsightsV2RatingsReviewsInteractionHoverOffer,
  businessInsightsV2RatingsReviewsInteractionSendOffer,
  TargetContentFilterRatingsValueType,
} from 'core/telemetry/avo/Avo';

import { InsightEntity } from './types';

export const telemetryClickDatePickerInHomeInsightPage = (
  targetContentDatePicker?: TargetContentDatePickerValueType,
) => {
  businessInsightsInteractionClickDatePicker({
    targetContentDatePicker,
  });
};

export const telemetrySelectPerformanceChartInHomeInsightPage = (sourceTitle: SourceTitleValueType) => {
  businessInsightsInteractionClickChartSource({
    sourceTitle,
  });
};

export const telemetryClickFilterRatingsInInsightsV2RatingsReviews = (
  targetContentFilterRatings: TargetContentFilterRatingsValueType = 'filter_ratings_value_1',
) => {
  businessInsightsV2RatingsReviewsInteractionClickFilterRatings({
    targetContentFilterRatings,
  });
};

export const useTelemetryBusinessInsightV2View = (entityType: EntityType) => {
  useTelemetryViewEvent('businessInsightsV2View', { viewType: entityType }, (durationMs, context) =>
    businessInsightsV2View({ durationMs, ...context }),
  );
};

export const useTelemetryBusinessInsightsV2PerformanceView = (entityType: EntityType) => {
  useTelemetryViewEvent('businessInsightsV2PerformanceView', { viewType: entityType }, (durationMs, context) =>
    businessInsightsV2PerformanceView({ durationMs, ...context }),
  );
};

export const useTelemetryBusinessInsightsV2OperationsView = (entityType: EntityType) => {
  useTelemetryViewEvent('businessInsightsV2OperationsView', { viewType: entityType }, (durationMs, context) =>
    businessInsightsV2OperationsView({ durationMs, ...context }),
  );
};

export const useTelemetryBusinessInsightsV2CustomerBaseView = (entityType: EntityType) => {
  useTelemetryViewEvent('businessInsightsV2CustomerBaseView', { viewType: entityType }, (durationMs, context) =>
    businessInsightsV2CustomerBaseView({ durationMs, ...context }),
  );
};

export const useTelemetryBusinessInsightsV2MenuView = (entityType: EntityType) => {
  useTelemetryViewEvent('businessInsightsV2MenuView', { viewType: entityType }, (durationMs, context) =>
    businessInsightsV2MenuView({ durationMs, ...context }),
  );
};

export const useTelemetryInsightsV2RatingsReviewsView = (entityType: EntityType) => {
  useTelemetryViewEvent('businessInsightsV2RatingsReviewsView', { viewType: entityType }, (durationMs, context) =>
    businessInsightsV2RatingsReviewsView({ durationMs, ...context }),
  );
};

export const telemetryBusinessInsightsV2SwitchToOld = (viewType: InsightEntity['type']) => {
  businessInsightsV2InteractionClickSwitchToOldInsights({ viewType });
};

export const telemetryRatingsAndReviewsSendOfferHover = () => {
  businessInsightsV2RatingsReviewsInteractionHoverOffer();
};

export const telemetryRatingsAndReviewsSendOfferClick = () => {
  businessInsightsV2RatingsReviewsInteractionSendOffer();
};

export { SourceTitle as ChartCategoryTelemetryEvent };
export { TargetContentDatePicker as PredefinedDateRangeOptions };
